const gameCatalog = [
  {
    id: 'holdem',
    name: "Texas Hold'em",
    summary: '德州扑克',
    path: '/games/texas-holdem',
    available: true,
    ctaLabel: '进入'
  },
  {
    id: 'gomoku',
    name: 'Gomoku',
    summary: '五子棋',
    path: '/games/gomoku',
    available: true,
    ctaLabel: '进入'
  }
];

export default gameCatalog;
